import styled, { css } from 'styled-components'
import { colors } from 'client/styles'

export const MobileOnlyContainer = styled.div`
  display: flex;
  color: ${colors.white};
  background-color: ${colors.green4};
  padding-block: 4px;
  padding-inline: 20px 8px;
  border-start-start-radius: 0;
  border-start-end-radius: 8px;
  border-end-start-radius: 0;
  border-end-end-radius: 8px;
  width: max-content;
  margin-inline-start: -20px;
`

export const MobileOnlyBase = styled.div`
  line-height: 22px;
  margin-block-end: ${props => (props.as === 'li' ? '4px' : '8px')};
  margin-block-start: 0;
  width: 100%;

  svg {
    flex: 0 0 auto;
    fill: ${colors.white};
    width: 20px;
    height: 20px;
  }

  p {
    width: 100%;
    display: block;
    font-size: 14px;
    line-height: 20px;
    margin-inline-start: 8px;
    font-weight: 700;

    &::first-letter {
      text-transform: uppercase;
    }
  }

  ${props =>
    props.variant === 'text' &&
    css`
      margin-block-end: 6px;
      svg {
        fill: ${props.theme.colors.success};
      }
      p {
        color: ${props.theme.colors.success};
        font-size: 16px;
      }

      ${MobileOnlyContainer} {
        background-color: ${props.theme.colors.grey8};
      }
    `}
`
